import BusinessCenterIcon from "@material-ui/icons/BusinessCenter";
import BusinessTypeList from "./BusinessTypeList";

export default {
  list: BusinessTypeList,
  icon: BusinessCenterIcon,
};
